import request from '@/utils/request'
// 分账接口：

// 新增分账方：post commission/createReceiver，参数：
// title // 名称
// alipay // 支付宝分账方参数，{account//账户，tyephood//类型，name//名称, relationType//分账关系}
// wepay // 微信分账方参数：{account//账户，typehood//类型, name//名称，relationType//分账关系}
// order// 排序
export function createReceiver(data) {
    return request({
        url: '/commission/createReceiver',
        method: 'post',
        data,
    })
}
// 注：typehood: 1//个人 2//公司，
// relationType: 1//门店，2//员工，3//店主，4//合作伙伴

// 修改分账方：post commission/updateReceiver，参数：
// receiverId // 分帐方ID
// title // 名称
// alipay // 支付宝分账方参数，{account//账户，tyephood//类型，name//名称, relationType//分账关系}
// wepay // 微信分账方参数：{account//账户，typehood//类型, name//名称，relationType//分账关系}
// order// 排序
export function updateReceiver(data) {
    return request({
        url: '/commission/updateReceiver',
        method: 'post',
        data,
    })
}
// 删除分账方：post commission/removeReceiver，参数：
// receiverId // 分帐方ID
export function removeReceiver(data) {
    return request({
        url: '/commission/removeReceiver',
        method: 'post',
        data,
    })
}
// 获取单个分帐房：get commission/findReceiver, 参数：
// receiverId // 分帐方ID
export function findReceiver(params) {
    return request({
        url: '/commission/findReceiver',
        method: 'get',
        params,
    })
}
// 获取分帐方列表：get commission/findReceiverList, 参数：
// page
// size
// keyword // 关键词 搜索标题
export function findReceiverList(params) {
    return request({
        url: '/commission/findReceiverList',
        method: 'get',
        params,
    })
}
// 获取分账记录列表：get commission/findRecordList，参数：
// page
// size
// branchId // 门店ID
// keyword // 搜索订单号
export function findRecordList(params) {
    return request({
        url: '/commission/findRecordList',
        method: 'get',
        params,
    })
}
// 手动分账：post commission/fixRecord，参数：
// recordId
export function fixRecord(data) {
    return request({
        url: '/commission/fixRecord',
        method: 'post',
        data,
    })
}
